import React, { Fragment, useRef, useState } from 'react';
import {
    Popover,
    IconButton,
    MenuList,
    MenuItem,
    Paper,
} from '@material-ui/core';
import {
    BookOpen,
    Eye,
    File,
    FileText,
    Image,
    MessageCircle,
    Plus,
} from 'react-feather';
import { amber, blue, green, pink, purple } from '@material-ui/core/colors';
import { useTranslation } from 'react-i18next';
import { CONTACT_REGISTRATION_LABELS } from '../../constants/contactRegistration';

export const OptionsMenu = ({
    disabled = false,
    canCreateContact = false,
    canViewLinkedContact = false,
    onSendTemplate,
    onOpenDocumentation,
    onOpenFilePicker,
    onOpenCreateContact,
    onOpenLinkedContact,
    hasPresentationCard = false,
    onSendPresentationCard,
}: {
    disabled?: boolean;
    canCreateContact?: boolean;
    canViewLinkedContact?: boolean;
    onSendTemplate?: () => void;
    onOpenDocumentation?: () => void;
    onOpenFilePicker?: () => void;
    onOpenCreateContact?: () => void;
    onOpenLinkedContact?: () => void;
    hasPresentationCard?: boolean;
    onSendPresentationCard?: () => void;
}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    const handleToggleOpen = () => {
        if (disabled) return;
        setOpen(!open);
    };

    const handleClose = () => setOpen(false);

    const handleOptionClick = (onClick?: () => void) => {
        handleClose();
        onClick?.();
    };

    const options = [
        {
            icon: <MessageCircle style={{ fontSize: 20, color: green[300] }} />,
            onClick: onSendTemplate,
            label: t('Chat.SendTemplate'),
            showIf: true,
        },
        {
            icon: <File style={{ fontSize: 20, color: purple[300] }} />,
            label: t('Chat.SendFile'),
            onClick: onOpenFilePicker,
            showIf: true,
        },
        {
            icon: <FileText style={{ fontSize: 20, color: pink[300] }} />,
            label: t('Chat.SendDocumentation'),
            onClick: onOpenDocumentation,
            showIf: true,
        },
        {
            icon: <Image style={{ fontSize: 20, color: blue[300] }} />,
            label: t('PresentationCard.SendPresentationCard'),
            showIf: true,
            onClick: onSendPresentationCard,
            disabled: !hasPresentationCard,
        },
        {
            icon: <BookOpen style={{ fontSize: 20, color: amber[300] }} />,
            label: t('Chat.CreateContact'),
            onClick: onOpenCreateContact,
            showIf: canCreateContact,
        },
        {
            icon: <Eye style={{ fontSize: 20, color: amber[300] }} />,
            label: t(`Chat.${CONTACT_REGISTRATION_LABELS.viewContact}`),
            onClick: onOpenLinkedContact,
            showIf: canViewLinkedContact,
        },
    ];

    return (
        <Fragment>
            <Popover
                open={open}
                onClose={handleClose}
                anchorEl={buttonRef.current}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Paper>
                    <MenuList>
                        {options
                            .filter((option) => option.showIf)
                            .map((option, index) => (
                                <MenuItem
                                    key={index}
                                    onClick={() =>
                                        handleOptionClick(option.onClick)
                                    }
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                    }}
                                >
                                    {option.icon} {option.label}
                                </MenuItem>
                            ))}
                    </MenuList>
                </Paper>
            </Popover>

            <IconButton
                color="primary"
                onClick={handleToggleOpen}
                ref={buttonRef}
                disabled={disabled}
            >
                <Plus />
            </IconButton>
        </Fragment>
    );
};
